import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const VolumeHighSolidIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path d="M9 1.878c0-.702-.736-1.141-1.31-.702L3.028 4.51H.818c-.49 0-.818.35-.818.877v5.264c0 .526.327.877.818.877h2.21l4.663 3.334c.573.351 1.309 0 1.309-.702V1.878ZM12.596 2.343a.75.75 0 0 1 1.06 0 8 8 0 0 1 0 11.314.75.75 0 0 1-1.06-1.06 6.498 6.498 0 0 0 0-9.193.75.75 0 0 1 0-1.06Z"/>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M10.475 4.464a.75.75 0 0 1 1.06 0 5 5 0 0 1 0 7.072.75.75 0 1 1-1.06-1.061 3.5 3.5 0 0 0 0-4.95.75.75 0 0 1 0-1.06Z"/>
    </svg>
);
VolumeHighSolidIcon.displayName = 'VolumeHighSolidIcon';
export default VolumeHighSolidIcon;
